import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next, useTranslation } from "react-i18next"
import apiMessagesEn from "./locales/en/apiMessages.json"
// English translations
import authEn from "./locales/en/auth.json"
import chatsEn from "./locales/en/chats.json"
import commonEn from "./locales/en/common.json"
import communitiesEn from "./locales/en/communities.json"
import dashboardEn from "./locales/en/dashboard.json"
import myRitualityEn from "./locales/en/myRituality.json"
import onboardingEn from "./locales/en/onboarding.json"
import profileEn from "./locales/en/profile.json"
import ritualsEn from "./locales/en/rituals.json"
import settingsEn from "./locales/en/settings.json"
import apiMessagesEs from "./locales/es/apiMessages.json"
// Spanish translations
import authEs from "./locales/es/auth.json"
import chatsEs from "./locales/es/chats.json"
import commonEs from "./locales/es/common.json"
import communitiesEs from "./locales/es/communities.json"
import dashboardEs from "./locales/es/dashboard.json"
import myRitualityEs from "./locales/es/myRituality.json"
import onboardingEs from "./locales/es/onboarding.json"
import profileEs from "./locales/es/profile.json"
import ritualsEs from "./locales/es/rituals.json"
import settingsEs from "./locales/es/settings.json"

export const resources = {
  en: {
    auth: authEn,
    onboarding: onboardingEn,
    dashboard: dashboardEn,
    settings: settingsEn,
    profile: profileEn,
    rituals: ritualsEn,
    communities: communitiesEn,
    chats: chatsEn,
    common: commonEn,
    apiMessages: apiMessagesEn,
    myRituality: myRitualityEn,
  },
  es: {
    auth: authEs,
    onboarding: onboardingEs,
    dashboard: dashboardEs,
    settings: settingsEs,
    profile: profileEs,
    rituals: ritualsEs,
    communities: communitiesEs,
    chats: chatsEs,
    common: commonEs,
    apiMessages: apiMessagesEs,
    myRituality: myRitualityEs,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    debug: false,

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "rituality-language",
    },

    interpolation: {
      escapeValue: false,
    },

    ns: [
      "auth",
      "onboarding",
      "dashboard",
      "settings",
      "profile",
      "rituals",
      "communities",
      "chats",
      "common",
      "apiMessages",
      "myRituality",
    ],
    defaultNS: "common",
  })

export default i18n
export { useTranslation }
